export { analyticsTracker } from './analytics-tracker.esm.js';
export { classNames } from './classnames.esm.js';
export { Level, liveAnnounce } from './live-announce.esm.js';
export { ScriptLoader } from './script-loader.esm.js';
export { UitkContextProvider, UitkContextWrapper, useUitkContext } from './uitk-context-provider.esm.js';
export { validateChildTypeNames, validateChildTypes } from './validate-child-types.esm.js';
export { validatePropType } from './validate-prop-types.esm.js';
export { isElementVisible } from './is-element-visible.esm.js';

if (typeof document !== 'undefined') {
    var addBodyClass_1 = function () {
        if (!document.body.classList.contains('uitk-no-outline')) {
            document.body.classList.add('uitk-no-outline');
            // Manage event listeners
            document.body.removeEventListener('mousedown', addBodyClass_1);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            document.body.addEventListener('keydown', removeBodyClass_1);
        }
    };
    var removeBodyClass_1 = function () {
        if (document.body.classList.contains('uitk-no-outline')) {
            document.body.classList.remove('uitk-no-outline');
            // Manage event listeners
            document.body.removeEventListener('keydown', removeBodyClass_1);
            document.body.addEventListener('mousedown', addBodyClass_1);
        }
    };
    // Auto-initialize
    addBodyClass_1();
}
